import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Manually scroll hash anchors into view.
 * SSR is required for this browser-feature to work reliably out-of-the-box.
 * The interval runs for approx. 10 seconds if it finds a hash to search for.
 * This implementation is prone to race-conditions.
 */
export const useAnchor = () => {
    const location = useLocation()

    useEffect(() => {
        const hash = location.hash.replace('#', '')
        if (!hash) return
        let i = 0
        const interval = setInterval(() => {
            const anchor = document.getElementById(hash)
            if (anchor) {
                anchor.scrollIntoView()
                clearInterval(interval)
            } else if (i++ > 100) {
                clearInterval(interval)
            }
        }, 100)
        return () => clearInterval(interval)
    }, [location.hash])
}
